import Vue from 'vue';
import ActionModal from '../components/ActionModal';
import LinkSalesforceAccount from '../components/LinkSalesforceAccount';
import LinkWealthboxAccount from '../components/LinkWealthboxAccount';
import SalesforceImportGroups from '../components/SalesforceImportGroups';
import WealthboxImportGroups from '../components/WealthboxImportGroups';
import SelectAndImportGroupsFromRedtail from '../components/SelectAndImportGroupsFromRedtail';
import OnboardingImportContacts from '../components/OnboardingImportContacts';

Vue.component('onboarding', {
  components: {
    ActionModal,
    LinkSalesforceAccount,
    LinkWealthboxAccount,
    SalesforceImportGroups,
    WealthboxImportGroups,
    SelectAndImportGroupsFromRedtail,
    OnboardingImportContacts,
  },
  data() {
    return {
      salesforceStatus: false,
      wealthboxStatus: false,
    };
  },
  methods: {
    onSalesforceIntegrationStatus(status) {
      this.salesforceStatus = status;
    },
    onWealthboxIntegrationStatus(status) {
      this.wealthboxStatus = status;
    },
  },
  props: {
    vesselId: {
      type: Number,
      required: true,
    },
  },
});
